
<template>
    <div class="order" @click="getOrder">
        <div class="mainBar">
          <div class="leftBar">
            <div class="search">
              <span>查询</span>
              <el-input
                placeholder="请输入账号/订单号"
                suffix-icon="el-icon-search"
                v-model="input1">
              </el-input>
            </div>
            <div class="time">
              <span>时间</span>
                <el-date-picker
                  v-model="value1"
                  type="datetimerange"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
                </el-date-picker>
               <!--  <el-date-picker
                  v-model="value1"
                  type="datetime"
                  placeholder="开始时间" 
                  :picker-options="pickerOptions"
                  class="start">
                </el-date-picker>
                ~
                <el-date-picker
                  v-model="value2"
                  type="datetime"
                  placeholder="结束时间" 
                  :picker-options="pickerOptions"
                  class="end">
                </el-date-picker> -->
            </div>   
          </div>
          <div class="rightBar">
            <div class="name">
              <span>创建人</span>
              <el-select v-model="userid" @change="selectName" placeholder="请选择">
                <el-option 
                    v-for="item in names"
                    :key="item.userid"
                    :label="item.name"
                    :value="item.userid">
                </el-option>
              </el-select>
            </div>
            <div class="productname">
              <span>产品</span>
              <el-select v-model="id" @change="selectProduct" placeholder="请选择">
                <el-option
                  v-for="item in products"
                  :key="item.id"
                  :label="item.productname"
                  :value="item.id">
                </el-option>
              </el-select>
            </div> 
          </div>
          <el-button type="primary" @click="getOrder">查询</el-button>
          <el-button type="text" @click="reset">清空</el-button>
        </div>
        <div class="main">
        <!-- 列表 -->
          <el-table highlight-current-row :data="order.slice((currentPage-1)*pagesize,currentPage*pagesize)" stripe
              :header-cell-style="{'width':'15.71rem','color':'rgba(79,79,79,1)','text-align':'center','border-bottom':0,'font-weight':'bold'}" @click="getOrder">
                <el-table-column prop="orderid" width="210" label="单号"  sortable>
                </el-table-column>
                <el-table-column prop="productname" label="产品" sortable>
                </el-table-column>
                <el-table-column prop="saleprice" label="售价" sortable>
                </el-table-column>
                <el-table-column prop="user_num" label="账号" sortable>
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" sortable>
                </el-table-column>
                <el-table-column prop="status" label="状态" :formatter="formatStatus" sortable>
                </el-table-column>
                <el-table-column prop="name" label="创建人" sortable>
                </el-table-column> 
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]" 
            :page-size="pagesize"  
            layout="total, sizes, prev, pager, next, jumper"
            :total="order.length">  
          </el-pagination>
        </div>
      </div>
</template>
<script>
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'

  export default {
    data() {
      return {
        input1:'',
        value1:'',
        names:[],
        products:[],
        order:[],
        currentPage:1, //初始页
        pagesize:10, //每页的数据
        pickerOptions: {
          value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        },
        userid: '',
        id:''
      }
    },
    mounted(){
      this.getOrder();
      this.getUserAndJuniorName();
      this.getProductsSale();
      // this.getSearchorder()
    },
    methods:{
      //创建人下拉框选中事件
      selectName(value){//这个就是value值
        let obj = {};
        obj = this.names.find((item)=>{//这里的userList就是上面遍历的数据源
          return item.userid === value;//筛选出匹配数据
        });
        // 获取创建人id
        setCookie('userid',obj.userid);
        // console.log(obj.userid);
        // console.log(obj.name);//我这边的name就是对应label的
      },
      //产品下拉框选中事件
      selectProduct(value){
        let obj = {};
        obj = this.products.find((item)=>{
          return item.id === value;
        });
        // 获取产品id
        setCookie('id',obj.id);
      },
      // 初始页currentPage、初始每页数据数pagesize和数据data
      handleSizeChange: function (size) {
        this.pagesize = size;
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
      },
      //状态显示转换
      formatStatus: function (row, column) {
        return row.status == 1 ? '已支付' : row.status == 0 ? '未支付' : '未知';
      },
      // 获取创建人接口
      getUserAndJuniorName:function(){
        axios.get("/scene/userAndJuniorName",{
          params:{
           token:getCookie('session')
          }
        }).then(res => {
          this.names=res.data.data;
          // console.log(res.data.data)
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 获取产品接口
      getProductsSale:function(){
        axios.get("/scene/productsSale",{
        }).then(res => {
          this.products=res.data.data;
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 获取订单列表和获取搜索验证接口(查询账号和时间)
      getOrder:function(){
        var orderid=$('.search>div>input').val();
        var beginTime=$('.time input').eq(0).val();
        var endTime=$('.time input').eq(1).val();
        axios.get("/scene/order",{
          params:{
            token:getCookie('session'),
            userNum:orderid,
            // 单号
            // outTradeNo:orderid,
            beginTime:beginTime,
            endTime:endTime,
            createrId:getCookie('userid'),
            productId:getCookie('id')
          }
        }).then(res => {
          this.order = res.data.data;
        }).catch((err)=>{
          console.log(err);
        })      
      },

      // 清空
      reset:function(){
        delCookie('userid');
        delCookie('id');
        var orderid=$('.search>div>input').val("");
        var beginTime=$('.time input').eq(0).val("");
        var endTime=$('.time input').eq(1).val("");
        var name=$('.name .el-input__inner').val("");
        var productname=$('.productname .el-input__inner').val("");
        axios.get("/scene/order",{
          params:{
            token:getCookie('session'),
         }
        }).then(res => {
        }).catch((err)=>{
          console.log(err);
        })      
      }
    }
  };
</script>
<style scoped lang="scss">
  .mainBar{
    width:15.71rem;
    height:1.4rem;
    background:rgba(255,255,255,1); 
  }
  .leftBar{
    float: left;
  }
  .rightBar{
    float: left;
  }
  .main{
    width:15.71rem;
    margin-top: 0.12rem;
    background:rgba(255,255,255,1);
  }
</style>
<style>
  .order .el-select-dropdown__item{
    text-align: center;
  }
  .el-pagination{
    text-align: center;
  }
  .order .el-button{
    padding: 0.15rem 0.25rem;
    float: right;
    margin-right: 0.3rem;
  }
  .el-picker-panel__link-btn{
    padding: 0.1rem 0.15rem;
  }
  .el-pagination{
    padding: 0;
    height: 0.75rem;
    text-align: center;
  }
  .el-pagination span:not([class*=suffix]){
    height:0.14rem;
    font-size:0.14rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
    line-height:0.78rem;
  }
  .el-pagination .btn-prev{
    margin-top: 0.2rem !important;
  }
  .el-pagination .el-pager{
    margin-top: 0.2rem;
  }
  .el-pagination .btn-next{
    margin-top: 0.2rem !important;
  }
  /*.number{
    margin-top: 0.2rem;
  }*/
  .el-pagination__total,.el-pager>li{
    font-size:0.14rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(79,79,79,1);
  }
  .el-pager>li.active{
    color:rgba(79,79,79,1);
  }
  .el-pagination__sizes .el-input .el-input__inner{
     height: 0.38rem;
  }
  .el-table .cell{
    text-align: center;
    font-size:0.16rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
  }
  .order .el-input__inner{
    font-size:0.14rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
 }
  .order .search{
    float: left;
  }
  .order .time{
    float: left;
  }
  .order .search>span{
    float: left; 
    text-align: center;
    width: 1rem;
  }
  .order .search .el-input{
    width: 2rem;
  }
  .order .time>span{
    float: left; 
    text-align: center;
    width: 1rem;
  }
  .order .rightBar{
    line-height: 0.7rem;
    margin-top: 0.1rem;
  }
  .order .rightBar .name{
    float: left;
  }
  .order .rightBar .productname{
    float: left;
  }
  .order .rightBar span{
    float: left; 
  }
  .order .name>span{
    width: 1rem;
    text-align: center;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  .order .productname>span{
    text-align: center;
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  .order .rightBar .el-select{
    float: left; 
  }
  .order .search .el-input{
    height: 0.4rem;
  }
  .order .time .el-input__icon{
    line-height: 0.4rem;
  }
  .order .search .el-input__icon{
    line-height: 0.4rem;
  }
  .order .time .el-date-editor .el-range__icon{
    margin: 0 0.1rem 0 0.04rem;
  }
  .order .time .el-date-editor .el-range-separator{
    line-height: 0.4rem;
    height: 0.4rem;
    margin: 0 0.1rem;
  }
  .order .search .el-input__inner{
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0;
    padding-left: 0.1rem;
    border:0.01rem solid rgba(196,196,196,1);
  }
  .order .time .el-input__inner{
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0;
    padding-left: 0.1rem;
    border:0.01rem solid rgba(196,196,196,1);
  }
  .order .time .el-range-editor.el-input__inner{
    padding: 0 0 0 0.1rem;
    width: 5.5rem;
  }
  .order .leftBar{
    margin-right: 1rem;
  }
  .order .leftBar .search{
    line-height: 0.7rem;
  }
  .order .leftBar .time{
    line-height: 0.7rem;
  }
  .order .rightBar .el-input{
    width:2rem;
    height:0.4rem;
    line-height: 0.4rem;
  }
  .order .rightBar .el-input__inner{
    width:2rem;
    height:0.4rem;
    line-height: 0.4rem;
    border-radius: 0;
    border:0.01rem solid rgba(196,196,196,1);
    padding-left: 0.1rem;
  }
  .order .rightBar .el-input--suffix .el-input__inner {
     padding-right: 0; 
  }
  .order .rightBar .el-input__icon{
    line-height: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/order.vue